"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactQuery = require("react-query");
var _core = require("@folio/stripes/core");
var _utils = require("../../utils");
const useAppSettings = _ref => {
  let {
    endpoint,
    keyName,
    options,
    returnQueryObject = false,
    sectionName,
    queryParams
  } = _ref;
  const ky = (0, _core.useOkapiKy)();
  const defaultQueryParamObject = {
    perPage: 100,
    stats: false
  };
  const namespaceArray = [endpoint];
  if (sectionName) {
    defaultQueryParamObject.filters = [...(defaultQueryParamObject.filters ?? []), {
      path: 'section',
      value: sectionName
    }];
    namespaceArray.push(sectionName);
  }
  if (keyName) {
    defaultQueryParamObject.filters = [...(defaultQueryParamObject.filters ?? []), {
      path: 'key',
      value: keyName
    }];
    defaultQueryParamObject.perPage = 1;
    namespaceArray.push(keyName);
  }
  const queryParamArray = (0, _utils.generateKiwtQueryParams)(options ?? defaultQueryParamObject, {});
  namespaceArray.push(queryParamArray);
  const queryObject = (0, _reactQuery.useQuery)(namespaceArray, () => ky(`${endpoint}?${queryParamArray?.join('&')}`).json(), queryParams);
  if (returnQueryObject) {
    return queryObject;
  }
  if ((queryParams ?? defaultQueryParamObject)?.perPage && (queryParams ?? defaultQueryParamObject)?.perPage === 1) {
    return queryObject?.data?.[0] ?? {};
  }
  return queryObject?.data ?? [];
};
var _default = exports.default = useAppSettings;